import http from '@/core/http';

const store = {  
    actions: {
      // 获取门店列表
      GetStoreList (ctx, payload) {
        return http.req_get('/admin/action/getstorelist', { ...payload });
      },
      // 获取门店列表
      GetStoreListWithCity (ctx, payload) {
        return http.req_get('/admin/action/getstore4name', { ...payload });
      },
      // 获取门店信息
      GetStoreInfo (ctx, payload) {
        return http.req_get('/admin/action/storedetail', { ...payload });
      },
      // 设置门店信息
      SetStoreInfo (ctx, payload) {
        return http.req_post('/admin/action/savestoredetail', { ...payload });
      },
      // 获取门店首页模板
      GetIndexTemplate (ctx, payload) {
        return http.req_get('/admin/action/getmodelcontent', { ...payload });
      },
      // 清除实景配置
      DeletePlaceMap (ctx, payload) {
        return http.req_post('/admin/action/delplacemap', { ...payload });
      },
      // 获取门店区域
      GetStoreAreas (ctx, payload) {
        return http.req_get('/admin/action/storearea', { ...payload });
      },
      // 添加门店区域
      AddStoreAreas (ctx, payload) {
        return http.req_get('/admin/action/addarea', { ...payload });
      },
      // 修改门店区域
      SetStoreAreaInfo (ctx, payload) {
        return http.req_post('/admin/action/saveareadetail', { ...payload });
      },
      // 获取门店位置列表
      GetStorePlaces (ctx, payload) {
        return http.req_get('/admin/action/storeplace', { ...payload });
      },
      // 修改门店位置
      SetStoreSeatInfo (ctx, payload) {
        return http.req_post('/admin/action/saveplacedetail', { ...payload });
      },
      // 添加门店位置
      AddStoreSeat (ctx, payload) {
        return http.req_get('/admin/action/addplace', { ...payload });
      },
      // 门店绑定设备
      GetStoreBindDevices (ctx, payload) {
        return http.req_get('/admin/action/getstoredevlist', { ...payload });
      },
      // 区域绑定设备
      GetAreaBindDevices (ctx, payload) {
        return http.req_get('/admin/action/getareadevlist', { ...payload });
      },
      // 座位绑定设备
      GetPlaceBindDevices (ctx, payload) {
        return http.req_get('/admin/action/getplacedevlist', { ...payload });
      },
      // 门店绑定设备
      SetStoreBindDevices (ctx, payload) {
        return http.req_get('/admin/action/savestoredev', { ...payload });
      },
      // 区域绑定设备
      SetAreaBindDevices (ctx, payload) {
        return http.req_get('/admin/action/saveareadev', { ...payload });
      },
      // 座位绑定设备
      SetPlaceBindDevices (ctx, payload) {
        return http.req_get('/admin/action/saveplacedev', { ...payload });
      },
      // 获取位置设备指令
      GetPlaceCommandsConfig (ctx, payload) {
        return http.req_post('/admin/action/placeactioncommand', { ...payload });
      },
      // 设置位置设备指令
      SetPlaceCommandsConfig (ctx, payload) {
        return http.req_post('/admin/action/saveplacecommand', { ...payload });
      },
      // 快捷配置位置指令
      SetPlaceCommandSession (ctx, payload) {
        return http.req_post('/admin/action/setplacecommandbytype', { ...payload });
      },
      // 批量快捷配置位置指令
      SetPlaceCommandSessionBatch (ctx, payload) {
        return http.req_post('/admin/action/mulitsetplacecommandbytype', { ...payload });
      },
      // 设置设备自动断电开关
      SetDeviceAutoOff (ctx, payload) {
        return http.req_post('/admin/device/savemultidevattr', { ...payload });
      },
      // 获取小程序码列表
      GetMiniCodeList (ctx, payload) {
        return http.req_post('/admin/action/getqrlist', { ...payload });
      },
      // 获取小程序码
      GetMiniCodeData (ctx, payload) {
        return http.req_post('/admin/action/getqrimg', { ...payload }, { timeout: 60000 });
      },
      // 获取门店位置列表
      GetPlaceListKeyValue (ctx, payload) {
        return http.req_post('/admin/action/getplacelistbysid', { ...payload });
      },
      // 获取门店实景配置
      GetPlaceMap (ctx, payload) {
        return http.req_get('/admin/action/getplacemapdata', { ...payload });
      },
      // 设置位置主设备
      SetMainDeviceForPlace (ctx, payload) {
        return http.req_post('/admin/action/saveplacemaindid', { ...payload });
      },
      // 同步门店到售后系统
      SyncToMerchantManagerSystem (ctx, payload) {
        return http.req_post('/admin/action/syncstoretoas', { ...payload });
      },
      // 门店绑定/解绑网关
      StoreBindMac (ctx, payload) {
        return http.req_post('/admin/action/savestoremac', { ...payload });
      },
      // 商户号列表
      GetMchidlist(ctx, payload) {
        return http.req_get('/admin/action/getmchidlist', { ...payload });
      },
      // 更新商户号分账比例
      SaveChannelMchid (ctx, payload) {
        return http.req_post('/admin/action/saveChannelMchid', { ...payload });
      },
      // 门店绑定全域资金账户
      SaveGlobalMchid (ctx, payload) {
        return http.req_post('/admin/action/savestoreglobalsfundmchid', { ...payload });
      },
      // 添加绑定商户号
      AddBindMch (ctx, payload) {
        return http.req_post('/admin/action2/editBindMch', { ...payload });
      }
    }
  };
  
  export default store;